import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2d854dcf&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d854dcf')) {
      api.createRecord('2d854dcf', component.options)
    } else {
      api.reload('2d854dcf', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2d854dcf&", function () {
      api.rerender('2d854dcf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chooseImg/index.vue"
export default component.exports